import React from "react";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { TextInput } from "hesus-ui-kit";
import { GridRow, GridCell } from "../../AddEditInvoice.styled";
import "../../AddEditInvoice.scss";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  RequiredMessage,
} from "@utils/extra-style";

const InvoiceTotal = ({
  t,
  exchangeCurrencies,
  invoiceCurrency,
  exchangeRates,
  handleExchangeRateChange,
  totalExculdingTxes,
  taxesAmount,
  totalInculdingTxes,
  selectedVatDetail,
  currencyId,
  currencyList,
  page,
  exchangeRateErrors,
}) => {
  return (
    <GridRow
      column="1fr auto"
      background="#dff3f6"
      padding="10px 20px"
      margin="0px"
      borderRadius="0 0 5px 5px"
    >
      {/* Currency exchange */}
      <GridCell
        color="#444"
        fontSize="16px"
        fontWeight="700"
        display="flex"
        alignItems="center"
        style={{
          gap: "8px",
        }}
      >
        {page === "view" &&
          exchangeRates?.length > 0 &&
          exchangeRates.map((exchange, exchangeIndex) => {
            return (
              <GridRow
                key={"quoteservice-item-exchange-" + exchangeIndex}
                column="auto auto"
                padding="3px 0"
                gap="10px"
                background="transparent"
              >
                <GridCell
                  color="#474747"
                  fontSize="15px"
                  fontWeight="700"
                  textAlign="right"
                >
                  <>
                    {t("CLIENT_INVOICING_EXCHANGE_RATE")}(
                    {currencyList[exchange.currencyFrom]} {" -> "}
                    {invoiceCurrency}) :
                  </>
                </GridCell>
                <GridCell
                  color="#474747"
                  fontSize="15px"
                  fontWeight="400"
                  textAlign="right"
                >
                  {" "}
                  {exchange.exchangeRate}
                </GridCell>
              </GridRow>
            );
          })}
        {page === "create" &&
          exchangeCurrencies.map((item) => (
            <GridRow
              key={item.currency.id}
              column="auto auto"
              padding="3px 0"
              gap="10px"
              background="transparent"
            >
              <GridCell
                color="#444"
                fontSize="16px"
                fontWeight="700"
                textAlign="right"
              >
                {t("CLIENT_INVOICING_EXCHANGE_RATE")} ({item.currency.symbol}{" "}
                {" -> "}
                {invoiceCurrency})
              </GridCell>

              <GridCell>
                <TextInput
                  type="text"
                  value={
                    exchangeRates.find(
                      (rate) =>
                        Number(rate.currencyFrom) ===
                          Number(item.currency.id) &&
                        Number(rate.currencyTo) === Number(currencyId)
                    )?.exchangeRate ?? ""
                  }
                  onChange={(e) =>
                    handleExchangeRateChange(item.currency.id, e.target.value)
                  }
                  disabled={false}
                  name={`invoice-exchange-rate-${item.currency.id}`}
                  id={`invoice-exchange-rate-${item.currency.id}`}
                  errorStyles={{ "font-style": "italic" }}
                  labelStyles={
                    Boolean(exchangeRateErrors[Number(item.currency.id)])
                      ? labelStylesError
                      : labelStyles
                  }
                  inputStyles={
                    Boolean(exchangeRateErrors[Number(item.currency.id)])
                      ? inputStylesError
                      : inputStyles
                  }
                  containerStyles={{ marginTop: "-5px" }}
                  error={
                    Boolean(exchangeRateErrors[Number(item.currency.id)])
                      ? t("FIELD_REQUIRED")
                      : ""
                  }
                />
              </GridCell>
            </GridRow>
          ))}
      </GridCell>
      <GridRow column="1fr" padding="0px" gap="0px" background="transparent">
        {[
          ["CLIENT_INVOICING_TOTAL_EXC_TAX", totalExculdingTxes],

          [
            selectedVatDetail
              ? t("CLIENT_INVOICING_TOTAL_TAXES") +
                " (" +
                selectedVatDetail +
                ")"
              : "CLIENT_INVOICING_TOTAL_TAXES",
            taxesAmount,
          ],

          ["CLIENT_INVOICING_TOTAL_INC_TAX", totalInculdingTxes],
        ].map(([label, price]) => (
          <GridRow
            key={label}
            column="1fr auto"
            padding="3px 0px"
            gap="25px"
            background="transparent"
          >
            <GridCell
              color="#474747"
              fontSize="16px"
              fontWeight="700"
              textAlign="right"
              alignItems="flex-end"
            >
              {t(label)}
            </GridCell>

            <GridCell
              color="#0A4986"
              fontSize="16px"
              fontWeight="700"
              textAlign="right"
              alignItems="flex-end"
            >
              {price}
            </GridCell>
          </GridRow>
        ))}
      </GridRow>
    </GridRow>
  );
};

InvoiceTotal.propTypes = {
  isEditMode: PropTypes.bool,
  page: PropTypes.string,
};

InvoiceTotal.defaultProps = {
  isEditMode: false,
  page: "create",
};

export default withTranslation()(InvoiceTotal);
